import { canUseDOM } from './helper';

export enum DATALAYER_PAGE_EVENT {
  EARNING_PREFERENCE_SUCCESS = 'earning-preference-success',
  CONVERT_POINTS_SUCCESS = 'convert-points-success',
  CONVERT_POINTS_FAILURE = 'convert-points-failure',
  LOGIN_SUCCESS = 'login-success',
  LOGIN_FAILURE = 'login-failure',
  PROMOTION = 'promotion',
}

let ACCOUNT_DATALAYER_COUNTER: number = 0;
const updateDataLayerCounter = () => {
  ACCOUNT_DATALAYER_COUNTER = ACCOUNT_DATALAYER_COUNTER + 1;
};

export const updateDataLayerProperties = (
  dataLayerProperties: { [key: string]: unknown } | undefined,
  pageEvent: string,
  datalayerAction?: DataLayerActionType
) => {
  if (canUseDOM) {
    if (datalayerAction) {
      datalayerAction?.update({
        event: datalayerAction.eventName,
        ...dataLayerProperties,
      });
    } else {
      const dataLayer = window.dataLayer ?? {};
      if (dataLayerProperties) {
        Object.keys(dataLayerProperties).forEach(key => {
          dataLayer[key] = dataLayerProperties[key];
        });
      }
    }
    // update counter before updating hash
    updateDataLayerCounter();
    // Update the window.location.hash with the ACCOUNT_DATALAYER_COUNTER
    window.history.replaceState({}, '', `#page_name=${pageEvent}-${ACCOUNT_DATALAYER_COUNTER}`);
  }
};

export const updateDataLayerENVPlatformForDtt = (dataLayer?: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<Record<string, any>>;
  mvpOffersData: string;
}) => {
  /**
   * update data layer env platform for dtt
   *
   */
  const ENV_PLATFORM = 'env_platform';
  if (dataLayer?.data) {
    const data = dataLayer?.data[0];
    if (data) {
      const env_str = data[ENV_PLATFORM];
      data[ENV_PLATFORM] = `${env_str}-dtt`;
      return { ...dataLayer, data: [data] };
    }
    return dataLayer;
  }
  return dataLayer;
};
